import { Modal } from "../components/chrome/Modal";
import { useFeedbackDock } from "../components/chrome/FeedbackDock";
import { builderCopy } from "./copy";
import type { LimitSheetView } from "./limitSheetView";

/**
 * One sheet for a full plan (KEY-560), opened before anyone spends effort rather than after. Until the self-serve billing portal
 * (KEY-368) can take them to a larger plan, "Talk to us" opens the feedback dock, which reaches Key Dials from inside the app.
 */
export function LimitSheet({ view, onClose }: { view: LimitSheetView; onClose: () => void }) {
  const dock = useFeedbackDock();

  return (
    <Modal title={view.title} onClose={onClose} width={480}>
      <p className="kd-builder-limit-message">{view.message}</p>
      <div className="kd-builder-actions">
        <button type="button" className="kd-btn" onClick={onClose}>
          {builderCopy.limits.close}
        </button>
        <button
          type="button"
          className="kd-btn-primary"
          onClick={() => {
            onClose();
            dock.open();
          }}
        >
          {builderCopy.limits.talkToUs}
        </button>
      </div>
    </Modal>
  );
}
